import { useMemo } from 'react'

import { useForm } from 'react-hook-form'

import { zodResolver } from '@hookform/resolvers/zod'

import { useMissionSubmission } from '../../hooks/useMissionSubmission'

import { Mission } from '@/features/missions/types/mission'

import { EvidenceFormData, EvidenceKind, evidenceSchema } from './schemas'

interface UseEvidenceFormProps {
  mission: Mission
}

export function useEvidenceForm({ mission }: UseEvidenceFormProps) {
  const { submission } = useMissionSubmission({ id: mission.id })

  const evidenceKind = (mission.evidence_kind as EvidenceKind) || 'text'

  const defaultValues = useMemo((): EvidenceFormData => {
    switch (evidenceKind) {
      case 'link':
        return { evidenceKind, content: '' }
      case 'text':
        return { evidenceKind, content: '' }
      case 'image':
        return { evidenceKind, media_id: undefined }
      case 'qr_code':
        return { evidenceKind, content: '' }
      case 'default':
      default:
        return {
          evidenceKind,
          content: 'Completado sem necessidade de evidência'
        }
    }
  }, [evidenceKind])

  const form = useForm<EvidenceFormData>({
    resolver: zodResolver(evidenceSchema),
    defaultValues
  })

  const isSubmitted = submission?.status === 'approved' || false
  const isRefused = submission?.status === 'refused'
  const canSubmit = !isSubmitted || isRefused

  return {
    form,
    evidenceKind,
    submission,
    canSubmit,
    isSubmitted,
    isRefused
  }
}
